import { createSelector } from 'reselect'
import { fromSelector, toSelector } from './BookFormSelectors'
import { pathOr } from 'ramda'

import { createMainCities } from 'services/helpers'

const getState = state => state.city
const getRouteState = state => state.route
const getProps = (_, props) => props

const allCitiesSelector = state => getState(state).allCities
const routeCities = state => getState(state).routeCities
const returnRouteCities = state => getState(state).returnRouteCities
const isLoadingSelector = state => getState(state).isLoading
const routeInfo = state => getRouteState(state).info

const addDatesSelector = createSelector(
  routeCities,
  fromSelector,
  (cities, from) => {
    const city = cities.find(({ label }) => label === from)

    return pathOr(0, ['addDays'], city)
  }
)

const routeCitiesSelector = createSelector(
  allCitiesSelector,
  routeCities,
  routeInfo,
  (allCities, routeCities, { disabledCities = [] }) => (
    routeCities.map(city => {
      const { station } = allCities.find(({ id }) => id === city.id)

      if (disabledCities.length) {
        const disabled = disabledCities.includes(city.id)

        return {
          ...city,
          disabled,
          station
        }
      } else {
        return {
          ...city,
          disabled: false,
          station
        }
      }
    })
  )
)

const fromCityIdSelector = createSelector(
  fromSelector,
  allCitiesSelector,
  (fromLabel, allCities) => {
    const city = allCities.find(({ label }) => label === fromLabel)

    return city ? city.id : ''
  }
)

const toCityIdSelector = createSelector(
  toSelector,
  allCitiesSelector,
  (toLabel, allCities) => {
    const city = allCities.find(({ label }) => label === toLabel)

    return city ? city.id : ''
  }
)

const cityIdSagaSelector = createSelector(
  allCitiesSelector,
  getProps,
  (allCities, cityLabel) => {
    const city = allCities.find(({ label }) => label === cityLabel)

    return city ? city.id : ''
  }
)

const toCityRoutesSelector = createSelector(
  allCitiesSelector,
  toCityIdSelector,
  (allCities, toCityId) => {
    const city = allCities.find(({ id }) => id === toCityId)

    return city ? city.routes : []
  }
)

const fromCityRoutesSelector = createSelector(
  allCitiesSelector,
  fromCityIdSelector,
  (allCities, fromCityId) => {
    const city = allCities.find(({ id }) => id === fromCityId)

    return city ? city.routes : []
  }
)

const fromCityTypeSelector = createSelector(
  allCitiesSelector,
  fromCityIdSelector,
  (allCities, fromCityId) => {
    const city = allCities.find(({ id }) => id === fromCityId)

    return city ? city.type : null
  }
)

const fromCityTypeByLabelSelector = createSelector(
  allCitiesSelector,
  (_, { from }) => from,
  (allCities, fromCityLabel) => {
    const city = allCities.find(({ label }) => label === fromCityLabel)

    return city ? city.type : null
  }
)

const departurePlaceSelector = createSelector(
  allCitiesSelector,
  fromCityIdSelector,
  (allCities, fromCityId) => {
    const city = allCities.find(({ id }) => id === fromCityId)

    return city ? city.station : null
  }
)

const departurePlaceSagaSelector = createSelector(
  allCitiesSelector,
  (_, props) => props.from,
  (allCities, fromCityId) => {
    const city = allCities.find(({ id }) => id === fromCityId)

    return city ? city.station : null
  }
)

const departureTimeSagaSelector = createSelector(
  routeCities,
  (_, props) => props.from,
  (routeCities, fromCityId) => {
    const city = routeCities.find(({ id }) => id === fromCityId)

    return city ? city.departureTime : null
  }
)

const toCityTypeSelector = createSelector(
  allCitiesSelector,
  toCityIdSelector,
  (allCities, toCityId) => {
    const city = allCities.find(({ id }) => id === toCityId)

    return city ? city.type : null
  }
)

const fromToCitiesSelector = createSelector(
  fromCityIdSelector,
  toCityIdSelector,
  (fromCityId, toCityId) => `${fromCityId}_${toCityId}`
)

const mainCitiesSelector = createSelector(
  routeCitiesSelector,
  cities => createMainCities(cities) || []
)

const mainReturnCitiesSelector = createSelector(
  returnRouteCities,
  cities => createMainCities(cities) || []
)

const routeCitiesInfoSelector = createSelector(
  allCitiesSelector,
  mainCitiesSelector,
  mainReturnCitiesSelector,
  (allCities, routeCities, returnCities) => routeCities.map(city => {
    const { station, type } = allCities.find(({ id }) => id === city.id)
    const returnCity = returnCities.find(({ id }) => id === city.id)

    return {
      ...city,
      ...returnCity,
      station,
      type
    }
  })
)

export {
  allCitiesSelector,
  addDatesSelector,
  fromCityRoutesSelector,
  routeCitiesSelector,
  fromCityIdSelector,
  toCityIdSelector,
  toCityRoutesSelector,
  fromCityTypeSelector,
  toCityTypeSelector,
  fromToCitiesSelector,
  departurePlaceSelector,
  mainCitiesSelector,
  isLoadingSelector,
  fromCityTypeByLabelSelector,
  routeCitiesInfoSelector,
  cityIdSagaSelector,
  departurePlaceSagaSelector,
  departureTimeSagaSelector
}


// WEBPACK FOOTER //
// ./src/reduxModules/selectors/CitySelectors.js